import React from "react";

const sreya_sudheeran = () => {
  return (
    <div>
      <h1>Sreya Sudheeran</h1>

      <h4>
        <em>
          Computer Engineering, Batch of 27'
          <br />
          <hr />
        </em>
      </h4>

      <p>
        <strong>
          What was the criteria for shortlisting candidates in the initial
          stages of the recruitment process
        </strong>
        ?<br />
        Initially, 30 students were shortlisted based on their performance in
        the aptitude test. After that, the company selected 16 students from
        this group for the interview. The exact criteria for selection were not
        specified, but my guess is that it was based on CGPA or some aspects of
        the resume. For reference, my pointer was 9.56.
      </p>

      <p>
        <strong>What was the Timeline of the entire Interview Process</strong>?
        <br />
        The Aptitude Round was conducted first, and the results were announced
        soon after. Sixteen students were shortlisted for the interview rounds.
        The interviews were conducted the next day, and the final results were
        declared on the same day as the interviews concluded.
      </p>

      <p>
        <strong>What was the Structure of the Aptitude Round?</strong>
        <br />
        The Aptitude Round consisted of one coding question, along with
        technical questions covering topics from DBMS, Operating Systems, and
        general CS concepts. It also included aptitude questions, as well as
        company-related questions.
      </p>

      <p>
        <strong>
          How many students were shortlisted after the Aptitude Round?
        </strong>
        <br />A total of 16 students were shortlisted for the interview process.
      </p>

      <p>
        <strong>
          After being shortlisted, how long was the wait time before the
          interviews began? During this period, what specific areas did you
          focus on to prepare effectively?
        </strong>
        <br />
        The Aptitude Test was conducted on 30th July, followed by the interviews
        on 31st July, leaving very little time to prepare. During this short
        interval, I focused on revising the DBMS, CO, and OOPS concepts and
        thoroughly reviewed all the projects mentioned in my resume,
        particularly why specific data structures or libraries were used, their
        advantages, and how they contributed to the project’s functionality.
      </p>

      <p>
        <strong>
          How many Interview Rounds were there for the company, can you
          elaborate about each round in brief? Also mention, how many students
          were shortlisted after each Interview Round?
        </strong>
        <br />
        There were two rounds in total:
      </p>

      <ol>
        <li>
          <strong>Technical Round</strong>
          <br />
          The technical interview lasted for about an hour and covered a broad
          range of topics, testing both projects and in-depth technical
          knowledge. I was asked to open my GitHub profile to showcase my
          projects, explain my design choices, and justify the data structures
          and technologies I had used. I was also asked to write and explain
          some SQL queries, discuss query optimization, normalization, indexing,
          and table design.
          <br />
          The interviewer then asked questions on cache design, including which
          data structures could be used, designing an eviction policy, handling
          cache invalidation, and analyzing trade-offs between different cache
          architectures. Real-time scenarios involving caching were also
          discussed.
          <br />
          Additionally, there were questions on Java concepts, including
          Object-Oriented Programming, multithreading and synchronization,
          memory management, garbage collection, and exception handling.
          Probability-based analytical questions were also included.
          <br />
          Finally, I was asked about my previous internship experience and the
          tech stack I had worked with, linking my practical exposure to the
          technical discussion.
          <br />4 students were shortlisted after this round{" "}
        </li>
        <li>
          <strong>HR Round</strong>
          <br />
          The HR round began with mutual introductions and a discussion about my
          background and career goals. I was asked questions such as “Why
          IDeaS?” along with inquiries about my hobbies, achievements, and
          family background. The HR also included two puzzles — the classic
          torch and bridge puzzle and a mathematical puzzle. Additionally, there
          were situational and time management questions.{" "}
        </li>
        <li>3 students got the final offer</li>
      </ol>

      <p>
        <strong>
          What Topics or Skills did the interviewers focus on during the
          interviews? (e.g., DSA, Puzzles, DBMS, OS, Networks, System Design, or
          Behavioral questions)
        </strong>
        <br />
        The primary focus of the interviews was on my projects, along with
        concepts of DBMS and OOP in Java. During the HR round, puzzles were also
        included.{" "}
      </p>

      <p>
        <strong>
          What are some good resources that you used in your Internship Prep?
        </strong>
        <br />
        Striver’s A2Z DSA Sheet, LeetCode
      </p>

      <p>
        <strong>Some tips to crack Coding Questions?</strong>
        <br />
        Start with a structured learning plan, such as Striver’s A2Z Sheet, to
        build consistency in problem-solving, and focus on understanding the
        underlying logic before coding, prioritizing clarity over memorization.
      </p>

      <p>
        <strong>
          How many questions were asked about Projects, Clubs, and
          Extracurricular activities in your resume
        </strong>
        ?<br />
        The interviewer asked detailed questions about my projects and
        internship, with minimal focus on clubs or extracurricular activities.
      </p>

      <p>
        <strong>
          Is there something specific that you would want to tell people who are
          preparing for the same company
        </strong>
        ?<br />
        Make sure you have a thorough understanding of your resume, especially
        your projects and internships. Keep your projects and GitHub updated.
        Demonstrate a genuine interest in learning and align your answers with
        the company’s values and ethics.{" "}
      </p>

      <p>
        <strong>Any Final Tips for Juniors?</strong>
      </p>

      <p>
        Be honest and confident about what you know, and make sure your
        fundamentals are clear before the interview. Stay composed, as
        nervousness can affect even well-prepared answers, and most importantly,
        trust your preparation. The internship process can sometimes feel
        unpredictable, and luck may play a part, but it’s beyond your control.
        Focus on improving your skills, keep learning, and continue moving
        forward.{" "}
      </p>

      <p>Best of luck!</p>

      <p>
        <strong>Contact Info </strong>
        <br />
        <strong>Email :</strong> <a href="mailto:sreyasudheeran@gmail.com">sreyasudheeran@gmail.com</a>
      </p>

      <hr />
    </div>
  );
};

export default sreya_sudheeran;
